import Button from "@/components/Buttons/Button";
import { RichSBData } from "@/components/ProductPage/ProductPageHero/types";
import { PlantTagRecord } from "@/lib/algolia/plantTags";
import { render } from "storyblok-rich-text-react-renderer";
import styled from "styled-components";
import Add from "@/assets/svg/plus.svg";

const CoreInfoContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 2em;
`;

const ProductName = styled.h1`
  color: #10181c;
  font-family: Inter;
  text-wrap: pretty;
  font-size: clamp(1.3rem, 1.96vw + 2.11rem, 1.6rem);
  line-height: 1.2;
  font-weight: 500;
  letter-spacing: -0.276px;
  margin-bottom: 0rem;
`;

const ProductCode = styled.pre`
  color: #677076;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

const Description = styled.div`
  color: #677076;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.005rem;
  margin-top: 1rem;
  text-wrap: pretty;
`;

export default function ProductPageCoreInfo({
  record,
  RichSBData,
}: {
  record: PlantTagRecord;
  RichSBData: RichSBData;
}) {
  return (
    <CoreInfoContainer>
      <ProductName>
        {RichSBData?.content?.displayName && RichSBData?.content?.displayName !== ""
          ? RichSBData?.content?.displayName
          : record.Description}
      </ProductName>
      <ProductCode>{record.PlantPlan_Code}</ProductCode>
      {RichSBData?.content?.description && <Description>{render(RichSBData.content.description)}</Description>}
    </CoreInfoContainer>
  );
}
